import { render, staticRenderFns } from "./robot2.vue?vue&type=template&id=60fdb8b9&scoped=true&"
import script from "./robot2.vue?vue&type=script&lang=js&"
export * from "./robot2.vue?vue&type=script&lang=js&"
import style0 from "./robot2.vue?vue&type=style&index=0&id=60fdb8b9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60fdb8b9",
  null
  
)

export default component.exports